import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/tipoCentroCosto/importer/tipoCentroCostoImporterActions';

export default importerReducers(actions);
